export const PROFILE_OPEN_CLOSE_UPDATE_PASSWORD = "profile/editPassword/PROFILE_OPEN_CLOSE_UPDATE_PASSWORD";
export const PROFILE_UPDATE_PASSWORD = "profile/editPassword/PROFILE_UPDATE_PASSWORD";
export const PROFILE_UPDATE_PASSWORD_RESULT = "profile/editPassword/PROFILE_UPDATE_PASSWORD_RESULT";
